module.exports = __webpack_public_path__ + "static/media/marker.6efcd9a9.svg";